import { PropTypes } from "prop-types";
import DeleteIcon from "../../../assets/img/icons/delete.svg";
import EditIcon from "../../../assets/img/icons/edit-black.svg";
import { StyledDirectionTable } from "../../../styles/StyledDecision/StyledContent";
import { useState } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function DecisionDirection({ order, id, data, openModal = false, openEditModal, setDeletedId = false, setEditedId }) {
	const [searchParams] = useSearchParams();
	let type = "Information";
	let act = "";

	if (data?.url) {
		type = "Link";
		act = data.urlLabel;
	} else if (data?.followDecision) {
		type = "Follow decision";
		act = data.followDecision.name;
	} else if (data?.responsibleUser) {
		type = "Responsible user";
		act = `${data.responsibleUser.firstName} ${data.responsibleUser.lastName}`;
	} else if (data?.responsibleUnit) {
		type = "Responsible unit";
		act = data.responsibleUnit.name;
	}

	return (
		<>
			{type ? (
				<StyledDirectionTable>
					<span>{order}</span>
					<span>{data.description}</span>
					<span>{type}</span>
					<span>{type === "Link" ? <a href={data.url}>{data.urlLabel}</a> : act}</span>
					{searchParams.get("isMaker") !== "false" && (
						<div>
							<>
								<img
									onClick={() => {
										setEditedId(id);
										openEditModal();
									}}
									src={EditIcon}
									alt={EditIcon}
									role="img"
								/>
								<img
									onClick={() => {
										if (openModal) {
											setDeletedId(data.id);
											openModal();
										}
									}}
									src={DeleteIcon}
									alt={DeleteIcon}
									role="img"
								/>
							</>
						</div>
					)}
				</StyledDirectionTable>
			) : (
				<h1>test</h1>
			)}
		</>
	);
}

DecisionDirection.propTypes = {
	order: PropTypes.number,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	data: PropTypes.object,
	openModal: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	openEditModal: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	setDeletedId: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	setEditedId: PropTypes.func,
};
